module.exports = __webpack_public_path__ + "home-block-5-overlay@2x-21ABmxK.png";